import { createContext, useState, ReactNode, useContext } from 'react'
import { OTAUpdatePayload, OTA_STATUS } from '../../utils/otaTypes'

interface OTAUpdateContextProps {
    otaPayloadData: OTAUpdatePayload
    updateOtaPayloadData: (payload: OTAUpdatePayload) => void
}

const initialOtaPayload: OTAUpdatePayload = {
    type: 'progress', //TODO: Ska det här kunna vara error också?
    data: {
        state: OTA_STATUS.IDLE,
        value: 0
    }
}

const OTAUpdateContext = createContext<OTAUpdateContextProps>({
    otaPayloadData: initialOtaPayload,
    updateOtaPayloadData: () => {}
})

export const OTAUpdateProvider = ({ children }: { children: ReactNode }) => {
    const [otaPayloadData, setOtaPayloadData] = useState<OTAUpdatePayload>(initialOtaPayload)

    const updateOtaPayloadData = (payload: OTAUpdatePayload) => {
        setOtaPayloadData(payload)
    }

    return <OTAUpdateContext.Provider value={{ otaPayloadData, updateOtaPayloadData }}>{children}</OTAUpdateContext.Provider>
}

export const useOTAUpdateData = () => useContext(OTAUpdateContext).otaPayloadData
export const useChangeOTAUpdateData = () => useContext(OTAUpdateContext).updateOtaPayloadData
